import { render, staticRenderFns } from "./reaction.vue?vue&type=template&id=8eaf1ee2&scoped=true&"
import script from "./reaction.vue?vue&type=script&lang=js&"
export * from "./reaction.vue?vue&type=script&lang=js&"
import style0 from "./reaction.vue?vue&type=style&index=0&id=8eaf1ee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaf1ee2",
  null
  
)

export default component.exports